// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useShipmentHistoryDebouncedUpdateDraftParameter,
    useShipmentHistoryState,
} from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface ShipmentHistoryFilterFieldItemNumberProps {}

export interface ShipmentHistoryFilterFieldItemNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const shipmentHistoryFilterFieldItemNumberStyles: ShipmentHistoryFilterFieldItemNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = shipmentHistoryFilterFieldItemNumberStyles;

const ShipmentHistoryFilterFieldItemNumber: FC<ShipmentHistoryFilterFieldItemNumberProps> = () => {
    const { itemNumber } = useShipmentHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useShipmentHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(itemNumber);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        if (value !== itemNumber) {
            setValue(itemNumber);
        }
    }, [itemNumber]);

    const label = translate("Item #");

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                data-test-selector="shipmentHistory_itemNumberFilter"
                id={id}
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ itemNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default ShipmentHistoryFilterFieldItemNumber;
